import * as Yup from 'yup';
const validationSchema = Yup.object().shape({
  priceDenom: Yup.string().required('Price denom is required'),
  planDescription: Yup.array()
    .of(
      Yup.object().shape({
        title: Yup.string().required('Plan title is required'),
        description: Yup.string().required('Plan description is required'),
      }),
    )
    .min(1, 'At least one plan description is required'),
  title: Yup.string().required('Title is required'),
  price: Yup.number()
    .required('Price is required')
    .min(0, 'Price must be positive'),

  planType: Yup.string().required('Plan type is required'),
  notes: Yup.string(),
});

export default validationSchema;
